import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import CompanyNavBar from "../Components/companyNavBar";
import ProductVisual from "../Components/Visual/productVisual";
import Footer from "../Components/footer";
import ResultCard from "../Components/resultCard";
import ProductDetails from "../Components/productDetails";
import config from "../Api/config";
import { DatabaseProduct, DatabaseVariant } from "../Api/Database";
import { toast } from "react-toastify";
import ItemDetails from "../Components/Users/ItemDetails";
import { VariantCard } from "../Components/Users/VariantCard";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCircleCheck } from '@fortawesome/free-solid-svg-icons'

import MuiAccordion, { AccordionProps } from "@mui/material/Accordion";
import MuiAccordionSummary from "@mui/material/AccordionSummary";
import Typography from "@mui/material/Typography";
import { styled } from "@mui/material/styles";

import YouTube from 'react-youtube';
import OtherProductsVisual from "../Components/Visual/otherProductsVisual";


const Accordion = styled((props: AccordionProps) => (
    <MuiAccordion disableGutters elevation={0} square {...props} />
))(({ theme }) => ({
    border: `2px solid rgba(0, 0, 0, 0.03)`,
    "&:not(:last-child)": {
        borderBottom: 0,
    },
    "&:before": {
        display: "none",
    },
}));


function ItemPage() {


    const { item } = useParams();
    const [itemData, setItemData] = useState<any>({});
    const [productData, setProductData] = useState<any>({});
    const [brandData, setBrandData] = useState<any>({});
    const [manufacturerData, setManufacturerData] = useState<any>({});
    const [videoUrl, setVideoUrl] = useState("");
    const [variants, setVariants] = useState<DatabaseVariant[]>([]);
    const [newTime, setNewTime] = useState("");
    const notifyError = (err:any) => toast.error(err,{theme:"colored"});
    const [images, setImages] = useState<any>([]);

    useEffect(() => {
        // item
        if(item != undefined ) {
            config.API.getDpp(item).then((item) => {
                setItemData(item);
            }).catch(error => {
                console.error("Error in API for product: ", error);
                notifyError("Error: " + error);
            });
        }
    }, []);

    
    useEffect(() => {
        // get product info
        if(itemData.product_id != undefined ) {
            config.API.getProduct(itemData.product_id).then((item) => {
                setProductData(item);
                transformImg(item.image_gallery);
                if(item.video_url === '' && item.parent_id) {
                    config.API.getProduct(item.parent_id).then((parent) => {
                        setVideoUrl(parent.video_url.split("embed/")[1]);
                    })
                } else {
                    setVideoUrl(item.video_url.split("embed/")[1]);
                }
            }).catch(error => {
                console.error("Error in API for product: ", error);
                notifyError("Error: " + error);
            });
        }

        // get brand info
        if(itemData.owner_id != undefined){
            config.API.getOwner(itemData.owner_id).then((item) => {
                setBrandData(item);
            }).catch(error => {
                console.error("Error in API for product: ", error);
                notifyError("Error: " + error);
            });
        }

        // get manufacturer info
        if(itemData.manufacturer_id != undefined){
            config.API.getManufacturer(itemData.owner_id,itemData.manufacturer_id).then((item) => {
                setManufacturerData(item);
            }).catch(error => {
                console.error("Error in API for product: ", error);
                notifyError("Error: " + error);
            });
        }

        if(itemData.created_at != undefined){
            let temp = new Date(itemData.created_at * 1000).toLocaleString()
            setNewTime(temp)
        }

    }, [itemData]);

    function transformImg(images:any){
        let imgGallery:any[] = [];
        images.forEach((element:any) => {
            imgGallery.push({
                original: element,
                thumbnail: element,
            })
        });
        setImages(imgGallery);
    }

    
    useEffect(() => {
        // get variants 
        config.API.getVariantList( productData.parent_id === "" ? productData.id : productData.parent_id, "","").then((el) => {
            setVariants(el.results);
        }).catch(error => {
            console.error("Error in variant list API: ", error);
            notifyError("Error in variant list API: " + error);
        });

    }, [productData]);
    
    return (
        <div className="product">
            <div className="explorerPublic">
                <CompanyNavBar data={brandData} product={true}/>
                <ProductVisual />
                {Object.keys(productData).length !== 0 &&  <ResultCard data={productData} />}
                {/*Object.keys(productData).length !== 0 &&  <VariantCard data={variants} selected={itemData.product_id}/>*/}
                {Object.keys(productData).length !== 0 && Object.keys(brandData).length !== 0 &&  <ProductDetails productData={productData} brandData={brandData} add_space={true} images={images} />}
                {/* ITEM SECTION */}
                {Object.keys(productData).length !== 0 && Object.keys(brandData).length !== 0 &&  <ItemDetails manufacturer={manufacturerData} itemData={itemData} />}

            

                {/*<Accordion
                    key={"status"}
                    sx={{ width: "80%", margin: "auto"}}
                    id={"status"}
                >
                    <MuiAccordionSummary
                        sx={{ minHeight: "38px" }}
                    >
                        <Typography sx={{ fontSize: "16px", fontWeight: "500" }}>
                            Passport status: valid <FontAwesomeIcon icon={faCircleCheck} style={{color: "#368737"}}/><span style={{float:"right",paddingLeft:"30px"}}><small>{newTime}</small></span>
                        </Typography>
                    </MuiAccordionSummary>
                
                </Accordion>*/}

              <OtherProductsVisual variants={variants}/>
            

                { videoUrl && <div className="video-container" style={{marginTop:"30px", textAlign:"center",}}>
                    <h3 style={{textAlign:"left", paddingLeft:"46px"}}>Thank You from {brandData.name}</h3>
                    <YouTube  videoId={videoUrl} opts={{
                        height: '250',
                        width: '80%',
                        playerVars: {
                            // https://developers.google.com/youtube/player_parameters
                            autoplay: 0,
                        },
                    }} onReady={() => {
                            
                    }}></YouTube>
                </ div>}

                <p className="valid_credential">{newTime} Passport status: valid <FontAwesomeIcon icon={faCircleCheck} style={{color: "#368737"}} /> </p>
            </div>
            <Footer />
        </div>
    );
}

export default ItemPage;